import ScrollMagic from 'scrollmagic'
import * as Util from '../util/utilities'

const scrollcontrol = new ScrollMagic.Controller()

function cardAnimations($cards) {
    return [
        TweenMax.fromTo(
            $cards.find('[data-camp-card-bg]'),
            0.6,
            {
                x: '-104%',
            },
            {
                x: '0%',
                ease: Circ.easeInOut,
            },
        ),
        TweenMax.fromTo(
            $cards.find('[data-camp-card-accent]'),
            0.6,
            {
                x: '104%',
            },
            {
                x: '0%',
                ease: Circ.easeInOut,
            },
        ),
        TweenMax.fromTo(
            $cards.find('[data-camp-card-content]'),
            0.6,
            {
                y: '16%',
                opacity: 0,
            },
            {
                y: '0%',
                opacity: 1,
                delay: 0.48,
                ease: Power2.easeOut,
            },
        ),
    ]
}

export function campInfo() {
    const heroCard = window.innerWidth < 992 ? $('[data-hero] [data-camp-card]') : $()
    const scrollCards = $('[data-camp-card]').not(heroCard)

    if (heroCard.length) {
        new TimelineMax({ delay: 2 }).insertMultiple(cardAnimations(heroCard), 0, 0)
    }

    if (scrollCards.length) {
        Util.addAnimations(
            cardAnimations(scrollCards),
            '[data-hero]',
            '',
            window.innerHeight - window.innerHeight / 4,
            '',
            scrollcontrol,
            true,
        )
    }
}
